module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clear":"Clear","results":"results","content":"Content"},"nl":{"clear":"Wissen","results":"resultaten","content":"Inhoud"}}')
  delete Component.options._Ctor
}
